import { Tag } from "antd";
import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** CONTRACT BOOKING API CONFIG                                                       ***!
  \*******************************************************************************/

export const apiConfig = {
  //  BOND
  GetBondContract: BOM.baseUrl("bondcontracts", "treasury"),
  EditBondContract: BOM.baseUrl("bondcontracts", "treasury"),
  GetBondContracts: BOM.baseUrl("bondcontracts", "treasury"),
  CreateBondContract: BOM.baseUrl("bondcontracts", "treasury"),
  BondContractTemplate: BOM.baseUrl("bondcontracts/template", "treasury"),
  GetBondProduct: BOM.baseUrl("bondproducts", "treasury"),
  BondProductTemplate: BOM.baseUrl("bondproducts/template", "treasury"),
  Client: BOM.baseUrl("client"),

  // https://eclippseservice.project-demo.app/fineract-provider/api/v1/search?exactMatch=false&query=Clayton+Tinashe+Nyanyiwa&resource=clients,clientIdentifiers
  SearchCustomer: BOM.baseUrl("search"),
  GetUserAccounts: BOM.baseUrl("/clients/1864/accounts"),

  // TREASURY BILL
  GetTreasuryBillContracts: BOM.baseUrl("treasurybillcontracts", "treasury"),
  GetTreasuryBillContract: BOM.baseUrl("treasurybillcontracts", "treasury"),
  AddTreasuryBillContract: BOM.baseUrl("treasurybillcontracts", "treasury"),
  GetTreasuryBillContractTemplate: BOM.baseUrl(
    "treasurybillcontracts/template",
    "treasury"
  ),
  EditTreasuryBillContract: BOM.baseUrl("treasurybillcontracts", "treasury"),
  //  : BOM.baseUrl("treasurybillcontracts/template", "treasury"),

  // INTERBANK PLACEMENT
  Interbankplacementcontracts: BOM.baseUrl(
    "interbankplacementcontracts",
    "treasury"
  ),
  InterbankContractTemplate: BOM.baseUrl(
    "interbankplacementcontracts/template",
    "treasury"
  ),
  InterbankContract: BOM.baseUrl("interbankplacementcontracts", "treasury"),
  InterbankContractSearch: BOM.baseUrl("search"),
  Clients: BOM.baseUrl("clients"),
  InterBankPlacementProducts: BOM.baseUrl(
    "interbankplacementproducts",
    "treasury"
  ),
  InterBankPlacementTemplate: BOM.baseUrl(
    "interbankplacementproducts/template",
    "treasury"
  ),
  Counterparty: BOM.baseUrl("counterparty", "treasury"),
};

/*!*******************************************************************************!
  !*** CONTRACT BOOKING LABEL CONFIG                                                       ***!
  \*******************************************************************************/

export const labelConfig = {
  // INTERBANK PLACEMENT
  interBankPlacement: "Interbank Placement",
  manageContractBookingInterbankplacement: "Interbank Placement",
  contractBookingInterbankplacement: "Contract Listing",
  createContractBookingInterbankplacement: "Create Contract",
  viewContractBookingInterbankplacement: "Interbank Placement Details",
  updateContractBookingInterbankplacement: "Update Interbank Placement",
  updateContract: "Update Contract",
  generalInfo: "General Information",
  customerInfo: "Customer Info",
  productCode: "Product Code",
  productName: "Product Name",
  productType: "Product Type",
  productDescription: "Product Description",
  productIssuer: "Product Issuer",
  productIssuerType: "Product Issuer Type",
  branchCode: "Bank Code",
  branchName: "Branch Name",
  branchAddress: "Branch Address",
  branchCity: "Branch City",

  // TREASURY BILL
  treasuryBill: "Treasury Bill",
  manageContractBookingtTreasuryBill: "Treasury Bill",
  contractBookingtTreasuryBill: "Contract Listing",
  createContractBookingtTreasuryBill: "Create Contract",
  viewContractBookingtTreasuryBill: "Treasury Bill Details",
  updateContractBookingtTreasuryBill: "Update Treasury Bill",
  generalInfo: "General Information",

  // BOND
  bond: "Bond",
  manageContractBookingBond: "Bond",
  contractBookingBond: "Bond Contract",
  createContractBookingBond: "Create Contract",
  viewContractBookingBond: "Bond Details",
  updateContractBookingBond: "Update Bond",
  date: "Date",

  // Transactions
  transactionId: "Transaction ID",
  transactionType: "Transaction Type",
  transactionTypeDetail: "Transaction Type Detail",
  amount: "Amount",
  transactionDate: "Transaction Date",
  debit: "Debit",
  credit: "Credit",
  viewJournalEntries: "View Journal Entries",
  viewReceipt: "View Receipt",
  // Currency
  currency: "Currency",
  date: "Date",
  reversed: "Reversed",
  undoTransactionMsg: "Transaction successfully reversed",
  editTransactionMsg: "Transaction is successfully updated",
};

/*!*******************************************************************************!
  !*** CONTRACT BOOKING STATIC CONFIG                                                       ***!
  \*******************************************************************************/
export const staticConfig = {
  // INTERBNK PLACEMENT
  contractbookingInterbankPlacementBreadcrumbItems: [
    { title: labelConfig.interBankPlacement },
  ],
  newcontractbookingInterbankPlacement: [
    {
      title: (
        <Link to="/interbank-contract">{labelConfig.interBankPlacement}</Link>
      ),
    },
    {
      title: labelConfig.createContractBookingInterbankplacement,
    },
  ],
  viewcontractbookingInterbankPlacement: [
    {
      title: (
        <Link to="/interbank-contract">{labelConfig.interBankPlacement}</Link>
      ),
    },
    {
      title: labelConfig.viewContractBookingInterbankplacement,
    },
  ],
  editcontractbookingInterbankPlacement: [
    {
      title: (
        <Link to="/interbank-contract">{labelConfig.interBankPlacement}</Link>
      ),
    },
    {
      title: labelConfig.updateContractBookingInterbankplacement,
    },
  ],

  // TREASURY BILL
  contractbookingTreasuryBillBreadcrumbItems: [
    { title: labelConfig.treasuryBill },
  ],

  newcontractbookingTreasuryBill: [
    {
      title: (
        <Link to="/contract-booking-treasury-bill">
          {labelConfig.treasuryBill}
        </Link>
      ),
    },
    {
      title: labelConfig.createContractBookingtTreasuryBill,
    },
  ],
  viewContractbookingTreasuryBill: [
    {
      title: (
        <Link to="/contract-booking-treasury-bill">
          {labelConfig.treasuryBill}
        </Link>
      ),
    },
    {
      title: labelConfig.viewContractBookingtTreasuryBill,
    },
  ],
  editContractbookingTreasuryBill: [
    {
      title: (
        <Link to="/contract-booking-treasury-bill">
          {labelConfig.treasuryBill}
        </Link>
      ),
    },
    {
      title: labelConfig.updateContractBookingtTreasuryBill,
    },
  ],

  // BOND
  contractbookingBondBreadcrumbItems: [{ title: labelConfig.bond }],

  newContractBookingBond: [
    { title: <Link to="/bond-contract">{labelConfig.bond}</Link> },
    {
      title: labelConfig.createContractBookingBond,
    },
  ],

  viewContractBookingBond: [
    { title: <Link to="/bond-contract">{labelConfig.bond}</Link> },
    {
      title: labelConfig.viewContractBookingBond,
    },
  ],

  editContractBookingBond: [
    { title: <Link to="/bond-contract">{labelConfig.bond}</Link> },
    {
      title: labelConfig.updateContractBookingBond,
    },
  ],

  investorTypesOptions: [
    { label: "Individual", value: 0 },
    { label: "Corporate", value: 1 },
    { label: "Institutional", value: 2 },
  ],
  currencyOptions: [{ label: "Nigeria Naira", value: 0 }],
  bondTypeOptions: [
    { label: "Fixed Rate", value: 0 },
    { label: "Floating Rate", value: 1 },
    { label: "Zero Coupon", value: 2 },
    { label: "Convertible", value: 2 },
  ],
  bondIssuerType: [{ label: "Federal Government of Nigeria", value: 0 }],
  bondCouponPaymentFreq: [
    { label: "Anually", value: 0 },
    { label: "Semi-Anually", value: 1 },
    { label: "Quarterly", value: 2 },
  ],
  bondCreditRiskRatingOfIssuer: [
    { label: "Rating Agency", value: 0 },
    { label: "Rating", value: 1 },
  ],
  bondMarketRiskConsideration: [
    { label: "Interest Rate Risk", value: 0 },
    { label: "Liquidity Risk", value: 1 },
  ],
  bondConcentrationRisk: [
    { label: "Interest Rate Risk", value: 0 },
    { label: "Liquidity Risk", value: 1 },
  ],
  bondInvestorsApplicationForm: [
    { label: "Received", value: 0 },
    { label: "Pending", value: 1 },
  ],

  editContractbookingBond: [
    {
      title: <Link to="/bond-contract">{labelConfig.bond}</Link>,
    },
    {
      title: labelConfig.updateContractBookingtBond,
    },
  ],
  rolloverOption: [
    {
      // value: "manual",
      label: "Manual",
      value: false,
    },
    { label: "Auto", value: true },
  ],

  statusLabels: [
    { label: "All Status", value: "Status" },
    { label: "Active", value: "Active" },
    { label: "Pending", value: "Pending" },
    { label: "Approved", value: "Approved" },
    { label: "Matured", value: "Matured" },
    { label: "Rejected", value: "Rejected" },
    { label: "Closed", value: "Closed" },
  ],
};
